module.exports = __webpack_public_path__ + "static/media/login-img.2488c5ed.png";